module.exports = __webpack_public_path__ + "static/responsible-investment-4845db255e89a7de399137be0c185a7b.mp4";